// FullPageLoader.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import './FullPageLoader.css';

const FullPageLoader = () => {
  const { isGlobalLoading, globalLoadingMessage,globalLoadingMessageSecondary } = useSelector((state) => state.common);

  if (!isGlobalLoading) return null;

  return (
    <div className="fullpage-loader-overlay">
      <div className="loader-content">
        <div className="spinner"></div>
        <p>{globalLoadingMessage}</p>
        <p>{globalLoadingMessageSecondary}</p>
      </div>
    </div>
  );
};

export default FullPageLoader;